import React, { Component } from "react";
import PropTypes from "prop-types";
import icon from "../images/icone-doc-nao-assinado.svg";

const refusedReasonList = ["Eu discordo desse contrato", "Documento incorreto", "Desistência do processo", "Outro"];
export class DocumentNotSigned extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refusedReason: null,
    };
  }

  handleClick() {
    this.props.onBack();
  }

  handleClickNotSign = (param) => {
    this.props.notSign({ signed: param, refusedReason: this.state.refusedReason });
  };

  render() {
    return (
      <div className="container h-100">
        <div className="row px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            {!this.props.documentUnsigned ? (
              <>
                <h1 className="card-title fw-bold text-white mt-3 text-center">O DOCUMENTO NÃO FOI ASSINADO</h1>
                <h5 className="card-text text-light mt-2 mb-4 text-center">Ao recusar o documento essa ação não poderá ser desfeita.</h5>
                <h5 className="card-text text-light text-center">Selecione uma justificativa</h5>
                <div className="row justify-content-center" style={{ display: "grid" }}>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="justificativaRecusa" value="1" id="checkbox1" onClick={() => this.setState({ refusedReason: refusedReasonList[0] })} />
                    <label class="form-check-label" for="checkbox1">
                      {refusedReasonList[0]}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="justificativaRecusa" value="2" id="checkbox2" onClick={() => this.setState({ refusedReason: refusedReasonList[1] })} />
                    <label class="form-check-label" for="checkbox2">
                      {refusedReasonList[1]}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="justificativaRecusa" value="3" id="checkbox3" onClick={() => this.setState({ refusedReason: refusedReasonList[2] })} />
                    <label class="form-check-label" for="checkbox3">
                      {refusedReasonList[2]}
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="justificativaRecusa" value="4" id="checkbox4" onClick={() => this.setState({ refusedReason: refusedReasonList[3] })} />
                    <label class="form-check-label" for="checkbox4">
                      {refusedReasonList[3]}
                    </label>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-6 d-grid">
                    <button className="btn btn-primary fw-bold mt-5" type="button" onClick={() => this.handleClick()}>
                      VOLTAR
                    </button>
                  </div>
                  <div className="col-6 d-grid">
                    <button className="btn btn-secondary fw-bold mt-5" type="button" onClick={() => this.handleClickNotSign(0)} disabled={!this.state.refusedReason}>
                      CONFIRMAR RECUSA
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h1 className="card-title fw-bold text-white mt-3">O DOCUMENTO FOI RECUSADO COM SUCESSO</h1>
                <h5 className="card-text text-light mt-5">Caso necessite desfazer a ação, procure a empresa que precisa da sua assinatura.</h5>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

DocumentNotSigned.propTypes = {
  back: PropTypes.func.isRequired,
  notSign: PropTypes.func.isRequired,
  documentUnsigned: PropTypes.bool.isRequired,
};

export default DocumentNotSigned;
